module.exports = __webpack_public_path__ + "img/geraldinerolan.8f536db4.jpeg";